import {
  DataSourceFriendlyName,
  SALESFORCE_DATA_SOURCE_TYPE,
  SNOWFLAKE_DATA_SOURCE_TYPE,
} from '@/constants/data_sources';

export type PartnerMappingTerminology = {
  /** Friendly source name, e.g. "Salesforce" — used in the rule title and empty-state copy */
  sourceName: string;
  /** Singular object label for the column header and "map to the matching ___" copy, e.g. "Salesforce Account" */
  objectName: string;
  /** Plural object label for body and empty-state copy, e.g. "Salesforce accounts" */
  objectNamePlural: string;
  /** BittsSvg icon name for the object column header */
  icon: string;
};

/**
 * Scoped to the two consumers that exist today: the SFDC overlap push and the
 * Snowflake share. Extend per CRM (HubSpot "Company", Pipedrive "Organization",
 * Dynamics "Account", ...) when a new push consumer is added.
 */
const TERMINOLOGY_BY_FEED_TYPE: Record<string, PartnerMappingTerminology> = {
  [SALESFORCE_DATA_SOURCE_TYPE]: {
    sourceName: 'Salesforce',
    objectName: 'Salesforce Account',
    objectNamePlural: 'Salesforce accounts',
    icon: 'salesforceIcon',
  },
  [SNOWFLAKE_DATA_SOURCE_TYPE]: {
    sourceName: 'Snowflake',
    objectName: 'Snowflake Account',
    objectNamePlural: 'Snowflake accounts',
    icon: 'snowflakeIcon',
  },
};

export function getPartnerMappingTerminology(
  feedType: string | undefined,
): PartnerMappingTerminology {
  if (feedType && TERMINOLOGY_BY_FEED_TYPE[feedType]) {
    return TERMINOLOGY_BY_FEED_TYPE[feedType];
  }
  return {
    sourceName: (feedType && DataSourceFriendlyName[feedType]) || 'CRM',
    objectName: 'Account',
    objectNamePlural: 'accounts',
    icon: feedType ? `${feedType}Icon` : 'salesforceIcon',
  };
}

export function getPartnerMappingRuleTitle(
  feedType: string | undefined,
  nickname?: string | null,
) {
  const { sourceName } = getPartnerMappingTerminology(feedType);
  const suffix = nickname ? ` (${nickname})` : '';
  return `Define your ${sourceName} Partners${suffix}`;
}
